module.exports = __webpack_public_path__ + "icon_tyonantajuus.3fce113c0c9fce77e643.svg";